import { render } from "./InputButtonDev.vue?vue&type=template&id=06f9ce32"
import script from "./InputButtonDev.vue?vue&type=script&lang=js"
export * from "./InputButtonDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__